"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const BottomSheet_vue_1 = tslib_1.__importDefault(require("../../assets/uis/containers/BottomSheet.vue"));
const useI18n_1 = require("../../common/useI18n");
const __sfc_main = {};
__sfc_main.props = {
    visible: {
        type: Boolean,
        default: false
    },
    name: {
        type: String,
        default: ''
    },
    updatedTime: {
        type: String,
        default: ''
    },
    content: {
        type: String,
        default: ''
    },
    languageId: {
        type: Number,
        default: useI18n_1.LanguageId.EN
    }
};
__sfc_main.setup = (__props, __ctx) => {
    const props = __props;
    // 多语言
    const $t = (0, useI18n_1.useI18n)(props.languageId);
    const emit = __ctx.emit;
    const handleVisibleChange = (val) => {
        emit('update:visible', val);
    };
    const handleClose = () => {
        emit('close');
    };
    const handleAskAIMore = () => {
        emit('ask-ai-more');
    };
    const handleViewStockDetails = () => {
        emit('view-stock-details');
    };
    return {
        $t,
        handleVisibleChange,
        handleClose,
        handleAskAIMore,
        handleViewStockDetails
    };
};
__sfc_main.components = Object.assign({
    BottomSheet: BottomSheet_vue_1.default
}, __sfc_main.components);
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQUlBbmFseXNpc1BvcHVwLnZ1ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkFJQW5hbHlzaXNQb3B1cC52dWUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBNEJBLDBHQUFzRTtBQUN0RSxrREFBMkQ7QUFDM0QsTUFBTSxVQUFVLEdBQUcsRUFBRSxDQUFDO0FBQ3RCLFVBQVUsQ0FBQyxLQUFLLEdBQUc7SUFDakIsT0FBTyxFQUFFO1FBQ1AsSUFBSSxFQUFFLE9BQU87UUFDYixPQUFPLEVBQUUsS0FBSztLQUNmO0lBQ0QsSUFBSSxFQUFFO1FBQ0osSUFBSSxFQUFFLE1BQU07UUFDWixPQUFPLEVBQUUsRUFBRTtLQUNaO0lBQ0QsV0FBVyxFQUFFO1FBQ1gsSUFBSSxFQUFFLE1BQU07UUFDWixPQUFPLEVBQUUsRUFBRTtLQUNaO0lBQ0QsT0FBTyxFQUFFO1FBQ1AsSUFBSSxFQUFFLE1BQU07UUFDWixPQUFPLEVBQUUsRUFBRTtLQUNaO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsSUFBSSxFQUFFLE1BQU07UUFDWixPQUFPLEVBQUUsb0JBQVUsQ0FBQyxFQUFFO0tBQ3ZCO0NBQ0YsQ0FBQztBQUNGLFVBQVUsQ0FBQyxLQUFLLEdBQUcsQ0FBQyxPQUFPLEVBQUUsS0FBSyxFQUFFLEVBQUU7SUFDcEMsTUFBTSxLQUFLLEdBQUcsT0FBTyxDQUFDO0lBRXRCLE1BQU07SUFDTixNQUFNLEVBQUUsR0FBRyxJQUFBLGlCQUFPLEVBQUMsS0FBSyxDQUFDLFVBQVUsQ0FBQyxDQUFDO0lBQ3JDLE1BQU0sSUFBSSxHQUFHLEtBQUssQ0FBQyxJQUFJLENBQUM7SUFDeEIsTUFBTSxtQkFBbUIsR0FBRyxDQUFDLEdBQVksRUFBRSxFQUFFO1FBQzNDLElBQUksQ0FBQyxnQkFBZ0IsRUFBRSxHQUFHLENBQUMsQ0FBQztJQUM5QixDQUFDLENBQUM7SUFDRixNQUFNLFdBQVcsR0FBRyxHQUFHLEVBQUU7UUFDdkIsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDO0lBQ2hCLENBQUMsQ0FBQztJQUNGLE1BQU0sZUFBZSxHQUFHLEdBQUcsRUFBRTtRQUMzQixJQUFJLENBQUMsYUFBYSxDQUFDLENBQUM7SUFDdEIsQ0FBQyxDQUFDO0lBQ0YsTUFBTSxzQkFBc0IsR0FBRyxHQUFHLEVBQUU7UUFDbEMsSUFBSSxDQUFDLG9CQUFvQixDQUFDLENBQUM7SUFDN0IsQ0FBQyxDQUFDO0lBQ0YsT0FBTztRQUNMLEVBQUU7UUFDRixtQkFBbUI7UUFDbkIsV0FBVztRQUNYLGVBQWU7UUFDZixzQkFBc0I7S0FDdkIsQ0FBQztBQUNKLENBQUMsQ0FBQztBQUNGLFVBQVUsQ0FBQyxVQUFVLEdBQUcsTUFBTSxDQUFDLE1BQU0sQ0FBQztJQUNwQyxXQUFXLEVBQVgseUJBQVc7Q0FDWixFQUFFLFVBQVUsQ0FBQyxVQUFVLENBQUMsQ0FBQztBQUMxQixrQkFBZSxVQUFVLENBQUMifQ==